export default "__VITE_ASSET__B9CEz1gl__"